import { render, staticRenderFns } from "./Contact-us.vue?vue&type=template&id=b4a9a2d2&scoped=true&"
import script from "./Contact-us.vue?vue&type=script&lang=js&"
export * from "./Contact-us.vue?vue&type=script&lang=js&"
import style0 from "./Contact-us.vue?vue&type=style&index=0&id=b4a9a2d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a9a2d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VCard,VCol,VIcon,VRow,VSheet})
